import _ from 'lodash'

type Fn = <T extends string | Record<string, boolean>>(a: T, b?: T extends string ? Record<string, boolean> : never) => string


export const classNames: Fn = (a: string | Record<string, boolean>, map?: Record<string, boolean>): string => {
  let name = ''
  let args: Record<string, boolean> = {}

  if (typeof a === 'string')  {
    name = a
    args = map ?? {}
  } else {
    args = a
  }

  const extra = _(args).entries()
                  .filter(it => it[1])
                  .map(it => it[0])
                  .reduce((prev: string, acc: string) => `${acc} ${prev}`, '')
  return `${name} ${extra}`
}